import { useEffect, useRef, useState } from 'react';
import { useAuthMfaEnrolMutation } from '@platform/features/auth';
import type { IMfaSetup } from '@platform/features/auth';

/**
 * Секрет і otpauth-адреса для кроку підключення (POST /auth/mfa/enrol одразу після появи кроку): відповідь — у стані компонента (не в кеші
 * API), застаріла відповідь (крок уже закрито) відкидається; помилку отримує `onFail` з кодом сервера. Повторний виклик у StrictMode
 * сервер обслуговує тим самим секретом квитка.
 */
export function useMfaSetup(onFail: (code: string) => void): IMfaSetup | null {
  const [start] = useAuthMfaEnrolMutation();
  const [setup, setSetup] = useState<IMfaSetup | null>(null);
  const fail = useRef(onFail);
  fail.current = onFail;
  useEffect(() => {
    let live = true;
    start().unwrap().then((s) => { if (live) setSetup(s); }, (e: { code?: string }) => { if (live) fail.current(e.code ?? ''); });
    return () => { live = false; };
  }, [start]);
  return setup;
}
